module.exports = __webpack_public_path__ + "d5ce74f2d8d0ce5c1cce79aeb0c86de2.png";